<template>

  <popup
      v-if="isManager('project|finance|maintenance|admin|management')"

      button-style="info"
      heading="Add Equipment"
     :show-text="showText"
     :button-size="buttonSize"
     button-text="Add"
     button-icon="fa fa-cogs"
     :disable-save="false"
     :disable-button="!isManager('project|finance|maintenance|admin|management') || readOnly"
     @save="onSaveDialog"
     @close="onCloseDialog">

     <el-row>
       <el-col :span="24">
         <el-alert type="info" title="Note!"
         description="You can add equipment for any telco, not just the site sharers. If you need a new sharer, you must add that on the Sharer page."
         :closable="false" show-icon>
       </el-alert>
     </el-col>
   </el-row>

    <equip-details
      ref="ad"
      :owner-id="ownerId"
      :site-id="siteId"
      :editMode="true"
      :adding="true"
      :hide-panel="true"
      :action-step-id="actionStepId"
      :table-ref="tableRef"
    />

  </popup>

</template>


<script>

import EquipDetails from '@/components/assets/EquipDetails'

export default {

  components: {
    EquipDetails
  },

  props: {

    siteId: {
      type: Number,
      default: null
    },

    ownerId: {
      type: Number,
      default: null
    },

    showText: {
      type: Boolean,
      default: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    buttonSize: {
      type: String,
      default: 'small'
    },

    tableRef: {
      type: String,
      default: 'equiptable'
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    // XOL-596 (completed steps): the request step the equipment is added from (a request's
    // step 2); sent with the write so the API refuses it while that step is complete.
    actionStepId: {
      type: Number,
      default: null
    }

  },



  methods: {

    onSaveDialog () {
      this.$refs.ad.onSave()
      this.$emit('update-stats')
    },


    onCloseDialog () {
      this.$refs.ad.onClose()
      this.$emit('update-stats')
    }

  },


  data () {
    return {
      btnSize: this.buttonSize,
    }
  }

}

</script>
